/**
 * The hope is that this component can be the base for all forms.
 * No need to rewrite form JSX (i.e. CashAccountForm, LoanForm, InvestmentForm should now all become instances of ElementsForm).
 */

import { useEffect } from 'react';
import { FormProvider, SubmitHandler, UseFormReturn } from 'react-hook-form';

interface ElementsFormProps {
  registerSubmit?: (submitFn: () => void) => void;
  children?: React.ReactNode;
  className?: HTMLFormElement['className'];
  useFormReturn: {
    formMethods: UseFormReturn<any, any, undefined>;
    onSubmit: SubmitHandler<any>;
  };
}

export function ElementsForm({
  useFormReturn: { formMethods, onSubmit },
  children,
  className,
  registerSubmit,
}: ElementsFormProps) {
  useEffect(() => {
    if (registerSubmit) {
      const handleSubmit = () => formMethods.handleSubmit(onSubmit)();
      registerSubmit(handleSubmit);
    }
  }, []);
  return (
    <FormProvider {...formMethods}>
      <form className={className} onSubmit={formMethods.handleSubmit(onSubmit)}>
        {children}
      </form>
    </FormProvider>
  );
}
